module.exports = __webpack_public_path__ + "static/media/loading.49bb21bd.gif";